<template>
  <SocialBase :url="url" :fb-text="socialText" :tw-text="socialText" />
</template>

<script>
import { mapState } from 'vuex'
import SocialBase from '@/components/SocialBase'

export default {
  components: {
    SocialBase,
  },

  props: {
    videosList: {
      type: [Array, Object],
      required: true,
    },
  },

  computed: {
    ...mapState('favorites', ['sharingIds', 'socialText']),

    url() {
      let path

      if (this.sharingIds) {
        path = this.$router.resolve({
          name: 'SharedFavorites',
          params: { ids: this.sharingIds },
        }).href
      }

      return `${process.env.VUE_APP_MEDIA_URL}${path}`
    },
  },
}
</script>
